<template>
	<div class="position-relative" >
    <div class="row no-gutters justify-content-center">
      <div class="fixed-top d-block nav-bottom">
        <div class="custom-container-fluid px-0">
          <div class="row justify-content-center no-gutters">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
              <div class="bg-white h-100vh">
                <div class="w-100 bg-white">
                  <!-- title -->
                  <div class="container">
                    <div class=" position-relative">
                      <div class="row no-gutters justify-content-center">
                        <div class="fixed-top d-block nav-bottom">
                          <div class="custom-container-fluid  px-0">
                            <div class="row justify-content-center no-gutters">
                              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                                <div class="bg-green">
                                  <div class="w-100">
                                    <div class="row">
                                      <div class="col-10 py-14px div-wrapper">
                                        <p class="text-white heading-6 mb-0 px-4" style="width: max-content">Passanger Detail {{index+1}}</p>
                                      </div>
                                        <div class="col-1 cursor-pointer" @click="close()">
                                          <div class="nav-back" style="top: 15px!important;margin-left: -10px!important">
                                            <img src="../../assets/img/icon/cancel.png" width="15">
                                          </div>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-12">
                    <div class="container bg-white">
                      <div class="px-2 pb-4">
                        <div class="w-100 mb-3">
					                <p class="mb-0 body-3-3-1">Full name <span class="color-red">*</span></p>
					                <input type="text" class="form-control px-0 body-1-2 mb-1" v-model="result.name" />
					              </div>
					              <div class="w-100 mb-3">
					                <p class="mb-0 body-3-3-1">Date of birth <span class="text-danger">*</span></p>
					                <input type="text" class="form-control px-0 body-1-2 mb-1" placeholder="YYYY-MM-DD" @keypress="inputCustomOnly($event,'number_dash')" v-model="result.date_of_birth" />
					              </div>
					              <div class="w-100">
					                <p class="mb-0 body-3-3-1">Nationality <span class="text-danger">*</span></p>
					                <v-select class="general-select" :clearable="false" :options="country" v-model="result.nationality" label="name">
				                  </v-select>
					              </div>
                        <div class="mt-4">
                          <div @click="save" class="rounded-6 px-4 py-3 text-center" :class="{'bg-green cursor-pointer': is_form_valid, 'bg-green-disabled cursor-disable' : !is_form_valid}">
							              <p class="text-white body-15 mb-0 ls-1-25">Save</p>
							            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import country from "@/data/country"
  import {inputCustomOnly} from "@/utils/index.js";
	const { required,minLength,maxLength } = require("vuelidate/lib/validators");
	export default{
		props: ['data','index'],
		data(){
			return{
				country:country,
				result: {
					name: '',
					date_of_birth: '',
					nationality: {}
				}
			}
		},
		validations:{
			result:{
				name: {
					required
				},
				date_of_birth: {
					required,
          minLength: minLength(8),
          maxLength: maxLength(10)
				}
			}
		},
		created(){
			let copied_data = Object.assign({}, this.data)
			this.result = copied_data
		},
		computed:{
			is_form_valid(){
				return (this.$v.result.name.$invalid == false && this.$v.result.date_of_birth.$invalid == false && Object.keys(this.result.nationality).length > 0) ? true : false
			}
		},
		methods: {
      inputCustomOnly($event,value){
        inputCustomOnly(value,$event)
      },
			close(){
				this.$emit("close");
			},
			save(){
				let data_comeback = {
					data: this.result,
					index: this.index
				}
				this.$emit("save",data_comeback)
			}
		}
	}
</script>
<style scoped>
	input {
    border: none;
    border-radius: 0px !important;
    border-bottom: 1px solid #0000001A;
  }
  input:focus{
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;

  }
</style>


// WEBPACK FOOTER //
// src/components/ticket/PassengerForm.vue